import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { fireGamify } from "@/lib/gamify";
import { checkReminders } from "@/lib/api";

// Fires a daily "visit" gamification event once per browser session for a
// logged-in user. The backend awards points only once per calendar day.
export default function GamifyTracker() {
  const { user, ready } = useAuth();
  useEffect(() => {
    if (!ready || !user) return;
    const key = "dharmartha_visit_fired";
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
    fireGamify("visit");
    // Generate gentle in-app practice reminders (server dedupes per day).
    checkReminders().catch(() => {});
  }, [ready, user]);
  return null;
}
